<template>
  <el-dialog
    :visible.sync="visible"
    title="成本费用"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-width="120px"
    >
      <el-card style="margin-bottom:20px;">
        <div slot="header" class="card-header">
          <div>合同信息</div>
        </div>
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="合同编号：" prop="code">
              测试编号111
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户：" prop="customerId">
              测试客户
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="签订日期：" prop="signTime">
              2022-05-06
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交易货币：" prop="currency">
              美元
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交付日期：" prop="deadline">
              2022-11-01
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="合同文件：" prop="file"> </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注：" prop="remark"> 测试备注 </el-form-item>
      </el-card>

<el-tabs v-model="currentTab" type="card" >
    <el-tab-pane label="成本分析" name="1">
        <el-table
          :data="dataForm.detailList"
          border
          style="width: 100%"
        >
        <el-table-column label="产品名称" align="center">
            <template slot-scope="scope">
              {{ $productName(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="合同销售单价" align="center">
            <template slot-scope="scope">
              100
            </template>
          </el-table-column>
          <el-table-column label="加工费单价" align="center">
            <template slot-scope="scope">
              10
            </template>
          </el-table-column>
          <el-table-column label="原料成本单价" align="center">
            <template slot-scope="scope">
              20
            </template>
          </el-table-column>
          <el-table-column label="毛利润" align="center">
            <template slot-scope="scope">
             30
            </template>
          </el-table-column>
        </el-table>
    </el-tab-pane>
    <el-tab-pane label="合同明细" name="2">
        <el-table
          :data="dataForm.detailList"
          border
          style="width: 100%"
          :summary-method="getSummaries"
          show-summary
        >
          <el-table-column
            type="index"
            width="50"
            label="行号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column label="产品名称" align="center">
            <template slot-scope="scope">
              {{ $productName(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            label="品番号"
            prop="code"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="合同数量"
            header-align="center"
            align="center"
            width="120"
            prop="count"
          >
          </el-table-column>
          <el-table-column
            label="合同单价"
            header-align="center"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ moneyFormat(scope.row.amount) }}
            </template>
          </el-table-column>
          <el-table-column
            label="小计"
            header-align="center"
            align="center"
            width="140"
          >
            <template slot-scope="scope">{{
              computePrice(scope.row)
            }}</template>
          </el-table-column>
          <el-table-column
            label="备注"
            header-align="center"
            align="center"
            prop="remark"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            width="160"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-s-tools"
                size="mini"
                @click="showBomSaveDialog(scope.row, scope.$index)"
              >
                {{
                  `查看物料${
                    scope.row.bomList && scope.row.bomList.length > 0
                      ? "【" + scope.row.bomList.length + "】"
                      : ""
                  }`
                }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-tab-pane>
    <el-tab-pane label="采购明细" name="3">

    </el-tab-pane>
    <el-tab-pane label="加工明细" name="4"></el-tab-pane>
    <el-tab-pane label="出库单明细" name="5"></el-tab-pane>
  </el-tabs>
    </el-form>
  </el-dialog>
</template>

<script>
import moment from "moment";
import debounce from "lodash/debounce";
import BigNumber from "bignumber.js";

export default {
  components: {},
  data() {
    return {
      id: "",
      projectId: "",
      dataForm: {},
      currentDetailIndex: {},
      visible: false,
      currentTab:'1'
    };
  },
  computed: {
    canEditCustomer() {
      if (this.dataForm.id) {
        return true;
      }
      if (this.projectId) {
        return true;
      }
      return false;
    },
  },
  methods: {
    bomChanged(e) {
      console.log("bomChanged", e);
      this.dataForm.detailList[this.currentDetailIndex].bomList = [...e];
      console.log(
        "bomChanged",
        this.dataForm.detailList[this.currentDetailIndex].bomList
      );
    },
    showBomSaveDialog(row, index) {
      this.currentDetailIndex = index;
      this.$refs.BomSave.dataForm.detailList = row.bomList;
      this.$refs.BomSave.init();
      this.$nextTick(() => {
        this.$refs.BomSave.reset();
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      sums[0] = "合计";
      let totalAmount = new BigNumber(0);
      data.forEach((row) => {
        const count = new BigNumber(row["count"]);
        const price = new BigNumber(row["amount"]);
        console.log("getSummaries", count.isNaN(), price.isNaN());
        if (count.isNaN() || price.isNaN()) {
          return;
        }
        totalAmount = totalAmount.plus(count.multipliedBy(price));
      });
      sums[columns.length - 3] = totalAmount.toFixed(2);
      return sums;
    },
    countChange(e, row) {
      this.computePrice(row);
    },
    amountChange(e, row) {
      this.computePrice(row);
    },
    computePrice(row) {
      if (!row.count || !row.amount) {
        return "-";
      }
      let c = new BigNumber(row.count);
      let p = new BigNumber(row.amount);
      return c.multipliedBy(p).toFixed(2);
    },
    delRow(index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1);
      }
    },
    addRow(dataKey) {
      if (!dataKey) {
        dataKey = "detailList";
      }
      if (dataKey === "detailList") {
        this.dataForm[dataKey].push(this.getNewDetailRow());
      } else {
        this.dataForm[dataKey].push(this.getNewPurchaseRow());
      }
    },
    //创建合同明细新行对象
    getNewDetailRow() {
      return {
        name: "",
        code: "",
        color: "",
        size: "",
        attr1: "",
        attr2: "",
        amount: "",
        count: "",
        bomList: [],
      };
    },
    //创建原料明细新行对象
    getNewPurchaseRow() {
      return {
        name: "",
        code: "",
        color: "",
        size: "",
        attr1: "",
        amount: "",
      };
    },
    reset() {
      this.dataForm = {
        id: "",
        remark: "",
        totalAmount: "",
        code: "",
        currency: "美元",
        signTime: moment().format("yyyy-MM-DD"),
        customerId: "",
        detailList: [this.getNewDetailRow()],
        purchaseList: [this.getNewPurchaseRow()],
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.reset();
        if (this.id) {
          this.getInfo();
        }
        if (this.projectId) {
          this.getProjectCustomer();
        }
      });
    },
    getProjectCustomer() {
      this.$http
        .get(`/trade/project/${this.projectId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return;
          }
          this.dataForm.customerId = res.data.customerId;
          this.dataForm.projectName = res.data.name;
        });
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/agreement/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
        })
        .catch(() => {});
    },
    cancel() {
      this.$router.back();
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          let postForm = clone(this.dataForm);
          if (postForm.detailList && postForm.detailList.length === 0) {
            return this.$message.error("合同明细不能为空");
          }
          postForm.detailList.forEach((item) => {
            item.amount = new BigNumber(item.amount)
              .multipliedBy(100)
              .toFixed();
          });
          if (this.projectId) {
            postForm.projectId = this.projectId;
          }

          this.$http[!postForm.id ? "post" : "put"](
            "/trade/agreement/",
            postForm
          )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.cancel();
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
